class CustomerController extends AbstractEntityEditController
	@register()
	@inject '$scope',
		'customer'
		'shops'
		'registers'
		'Guid'
		'translate'
		'OrderRepository'
		'EntityAttributeService'
		'RenderRepository'
		'ConfigurationService'
		'MessageTerminal'
		'CouponsRepository'
		'CustomerRepository'
		'CustomerGroupRepository'
		'ShopRepository'
		'RegisterRepository'
		'IntegrationRepository'
		'VoucherRepository'
		'ToastService'
		'parseBool'
		'BACKEND_ORDER_STATUS'
		'integrations'
		'invoicedTransactionStatusEnum': 'BACKEND_INVOICED_TRANSACTION_STATUS'

	initialize: ->
		@mainCrud.entityType = 'wbo.customer.item.type'
		@mainCrud.entityTitle = 'wbo.customer.create.new'
		@mainCrud.showDelete = @ConfigurationService.isEnabled 'Backoffice.Customer.Delete'
		@mainCrud.showSave = @mainCrud.isNewEntity || @ConfigurationService.isEnabled 'Backoffice.Customer.Edit'
		@showSalesTaxExepmt = @ConfigurationService.isEnabled 'Shared.Setting.SalesTax.Enabled'
		@invoiceEnabled = @ConfigurationService.isEnabled 'Shared.Payment.InvoiceType.Enabled'
		@customer.customer_contacts ?= []
		@customer.customer_locations ?= []
		@originRegister = null
		@originShop = null
		@orders = null
		@giftcards = null
		@giftcardsSearching = false
		@webviewBaseUrl = null
		@filterDTO = new FilterDTO({
			itemsCount: 0
			sortProperty: 'timestamp'
		})
		@giftcardsFilterDTO = new FilterDTO({
			itemsCount: 0
			sortProperty: 'expire_date'
			sortDirection: 'ASC'
		})

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @customer.name

			if @customer.flat_discount_rate
				@customer.flat_discount_rate = parseFloat(@customer.flat_discount_rate)

			@hasPasswordSet = @customer.has_password
			@handleCompanyCvrBackwardsCompatibility()
		else
			@hasPasswordSet = false
			@customer.offline_customer = '0'
			@customer.is_sales_tax_exempt = '0'

		webviewBaseUrl = @ConfigurationService.get 'Shared.Customer.WebView.BaseURL', true

		if !_.isEmpty webviewBaseUrl
			@webviewBaseUrl = webviewBaseUrl

		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity(
			@customer,
			'BACKEND_CUSTOMER_ATTRIBUTE_TYPE',
			{
				allow_credit: '0'
				exclude_from_loyalty_points: '0'
				is_agreed_to_receive_emails: '0'
				company_name: null
				contact_person: null
				credit_limit: null
				loyalty_points: null
				sj_loyalty_points: null
				external_id: null
				origin_register_id: null
				origin_shop_id: null
			}
		)

		@initializeOriginData()

		@mainCrud.tabs = [
			{
				id: 'details'
				title: 'wbo.coupon.details'
				selector: '#tab-customer-details'
			}
			{
				id: 'orders'
				title: 'wbo.customer.tabs.customer.orders'
				selector: '#tab-customer-orders'
			}
			{
				id: 'contacts'
				title: 'wbo.customer.tabs.customer.contacts'
				selector: '#tab-customer-contacts'
			}
			{
				id: 'locations'
				title: 'wbo.customer.tabs.customer.locations'
				selector: '#tab-customer-locations'
			}
		]

		# The gift cards tab only makes sense for an existing customer (i.e. one that
		# already has an id) since gift cards are looked up by customer id.
		if !@mainCrud.isNewEntity
			@mainCrud.tabs.push(
				id: 'giftcards'
				title: 'wbo.title.voucher.list'
				selector: '#tab-customer-giftcards'
			)

			@MessageTerminal.on @$scope,
				@MessageTerminal.events.TAB_CHANGE,
				(tab) =>
					if tab.id == 'orders' && @orders == null
						@searchOrders()
					if tab.id == 'giftcards' && @giftcards == null
						@searchGiftcards()

		sjTrainsIntegration = _.find(@integrations, {id: 'sj_trains'})

		if sjTrainsIntegration? && sjTrainsIntegration.is_connected
			@IntegrationRepository
				.getConfiguration(sjTrainsIntegration.id)
				.then (response) =>
					@sjLoyaltyPointsEnabled = response.data.loyalty_points.is_enabled
		else
			@sjLoyaltyPointsEnabled = false

	initializeOriginData: ->
		query = @CustomerRepository.createQuery()
		query.withoutAnyRelations()

		if @attributesService.hasAttribute 'origin_shop_id'
			@ShopRepository
				.getEntity @attributesService.attributes.origin_shop_id.value, query
				.then (response) =>
					@originShop = response

		if @attributesService.hasAttribute 'origin_register_id'
			@RegisterRepository
				.getEntity @attributesService.attributes.origin_register_id.value, query
				.then (response) =>
					@originRegister = response

	save: ->
		@attributesService.persistAttributes()
		customer = angular.copy @customer

		if _.isEmpty(customer.password)
			delete customer.password

		customer.flat_discount_rate = parseFloat(customer.flat_discount_rate)
		customer.customer_groups = _.pluck customer.customer_groups, 'id'
		customer.shops = _.pluck(customer.shops, 'id')

		@CustomerRepository
			.save customer, @mainCrud.isNewEntity
			.then (response) =>
				@hasPasswordSet = response.data.has_password
				@customer.password = ''

				@afterSave response
			.catch (response) =>
				@handleErrors response.data
		@resetErrors()

	delete: ->
		@deleteEntity @CustomerRepository, @customer

	searchCustomerGroups: (name) ->
		query = @CustomerGroupRepository.createQuery()
		query.criteria 'name', 'LIKE', '%' + name + '%'
		query.setPagination 0, 50

		return @CustomerGroupRepository.findByQuery(query)

	searchShops: (name) ->
		return @ShopRepository.searchShops(name)

	addContact: ->
		@mainCrud.parent_form.$setDirty()
		@customer.customer_contacts.push(
			id: @Guid.generate()
			name: ''
			employee_number: ''
			email: ''
			phone: ''
		)

	removeContact: (contact) ->
		@mainCrud.parent_form.$setDirty()
		@customer.customer_contacts = _.reject(@customer.customer_contacts, {id: contact.id})

	addLocation: ->
		@mainCrud.parent_form.$setDirty()
		@customer.customer_locations.push(
			id: @Guid.generate()
			recipient_name: ''
			street_address: ''
			zip_code: ''
			city: ''
			country: ''
		)

	removeLocation: (location) ->
		@mainCrud.parent_form.$setDirty()
		@customer.customer_locations = _.reject(@customer.customer_locations, {id: location.id})

	searchOrders: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.with 'order_line_items',
			'order_line_items.addon_line_items'
			'order_line_items.bundled_line_items'
			'transactions'

		query.criteria 'customer_id', '=', @customer.id
		query.criteria 'status', '=', @BACKEND_ORDER_STATUS.COMPLETED

		@OrderRepository
			.getEntities query
			.then (orders) =>
				@orders = @OrderRepository.calculateOrderSum orders
				@filterDTO.itemsCount = @orders.length
			.finally =>
				@searching = false

	# Lists the internal gift cards bought in orders belonging to this customer, paginated/sorted via
	# @giftcardsFilterDTO (backed by GET /customer/{customerId}/list).
	searchGiftcards: ->
		@giftcardsSearching = true

		query = @giftcardsFilterDTO.getQuery()

		@VoucherRepository
			.findGiftcardsForCustomer @customer.id, query
			.then (response) =>
				@giftcards = _.map response.data.items, (giftcard) =>
					giftcard.expireDateMillis = if giftcard.expire_date then giftcard.expire_date * 1000 else null
					return giftcard
				@giftcardsFilterDTO.count = response.data.count
				@giftcardsFilterDTO.itemsCount = response.data.items.length
			.catch (response) =>
				@giftcards = []
				@ToastService.showErrors response, @translate('wbo.customer.tabs.customer.giftcards')
			.finally =>
				@giftcardsSearching = false


	isGiftcardValid: (giftcard) ->
		return giftcard.active &&
			(!giftcard.expire_date? || giftcard.expire_date >= moment().unix()) &&
			giftcard.units_left > 0

	# @TODO remove company_cvr external attribute backwards compatibility when old POSes no longer use it
	# Backwards compatibility is required for POS, but EntityAttributeService does not accept no longer
	# existing external attributes
	handleCompanyCvrBackwardsCompatibility: ->
		if angular.isUndefined(@customer) || angular.isUndefined(@customer.attributes)
			return

		@customer.attributes = @customer.attributes.filter (attribute) -> Object.keys(attribute)[0] != 'company_cvr'
